import { render, staticRenderFns } from "./release_edit.vue?vue&type=template&id=53463dfe&scoped=true"
import script from "./release_edit.vue?vue&type=script&lang=js"
export * from "./release_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53463dfe",
  null
  
)

export default component.exports